"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import PageHero from "@/components/common/PageHero";
import FAQComponent from "@/components/faq/FAQComponent";
import { getFaqs } from "@/services/api/faqApis";
import { FaqItem } from "@/types/faqTypes";

export default function FAQPageClient() {
    const [faqs, setFaqs] = useState<FaqItem[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const faqData = await getFaqs();
                const sorted = (faqData?.result || []).sort(
                    (a, b) => (a.order || 0) - (b.order || 0)
                );
                setFaqs(sorted);
            } catch (error) {
                console.error("Failed to load FAQs:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchFaqs();
    }, []);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <PageHero
                title="FAQs"
                subtitle="Frequently Asked Questions"
                backgroundImage="/images/about-us-banner.webp"
                mobileBackgroundImage="/images/about-us-banner-mob.webp"
            />
            <main className="min-h-screen">
                {loading ? (
                    <div className="w-full max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[76.04vw] mx-auto mt-12 sm:mt-16 lg:mt-20 mb-20 text-center text-[#8D8D8D]">
                        Loading FAQs...
                    </div>
                ) : (
                    <FAQComponent faqs={faqs} />
                )}
            </main>
        </motion.div>
    );
}
